module.exports = "<div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\">\n  <div class=\"jumbotron\">\n    <h1>Bienvenue à la pizzeria de DTA</h1>\n    <p>Commandez sur place, à emporter ou faîtes-vous livrer à domicile !</p>\n  </div>\n  <h2> Nos 3 dernières pizzas :</h2>\n</div>\n\n<div class=\"col-lg-4 col-md-4 col-sm-6 col-xs-12\"\n     ng-repeat=\"pizza in $ctrl.pizzas |limitTo:3 track by $index\">\n  <pizza pizza=\"pizza\"></pizza>\n  <ajouter-panier item=\"pizza\"></ajouter-panier>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/home.component/home.html
// module id = 75
// module chunks = 0